import config from "@/config";
import axios from "axios";

export async function getGoogleMapUrl(address) {
  const geocode = await getGoogleGeocode(address);

  if (!geocode) return null;

  return geocode.geometry.location;
}

async function getGoogleGeocode(address) {
  const { CD_GOOGLE_MAPS_API_KEY } = config;
  const baseUrl = 'https://maps.googleapis.com/maps/api/geocode/json';

  try {
    const res = await axios.get(baseUrl, {
      params: {
        address,
        key: CD_GOOGLE_MAPS_API_KEY,
      },
    });

    const result = res.data?.results?.[0];
    return result || null;
  } catch {
    return null;
  }
}

